import { render, staticRenderFns } from "./OrdersListsB2b.vue?vue&type=template&id=2a840572&scoped=true&"
import script from "./OrdersListsB2b.vue?vue&type=script&lang=js&"
export * from "./OrdersListsB2b.vue?vue&type=script&lang=js&"
import style0 from "./OrdersListsB2b.vue?vue&type=style&index=0&id=2a840572&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a840572",
  null
  
)

export default component.exports